import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      padding: '0px!important',
    },
    gridUserData: {
      padding: '0 0px!important',
    },
    textWelecom: {
      margin: '5px 0 0 0',
      fontSize: 14,
      color: '#4f5257',
    },
    textName: {
      margin: 0,
      fontSize: 15,
      color: '#35383d',
    },
    gridUserMenu: {
      padding: '0 0px!important',
    },
    btn: {
      justifyContent: 'space-between!important',
      padding: '0 12% 0 8%!important',
      width: '100%',
      margin: '20px 0 0 0!important',
    },
    textMenu: {
      textTransform: 'none',
      margin: 0,
      alignItems: 'center',
      display: 'flex',
      fontSize: 13,
      fontWeight: 500,
      color: '#4c4f53',
    },
    iconMenuLeft: {
      marginRight: 10,
    },
    icon: {
      width: 20,
      height: 20,
      marginLeft: 10,
      marginTop: 10,
      position: 'absolute',
    },
    iconSave: {
      marginLeft: 10,
    },
    btnFranchisee: {
      margin: '10px!important',
      padding: '5px 25px!important',
      borderRadius: '10px!important',
      backgroundColor: '#fef0ef!important',
      bottom: 90,
    },
    textBtnFranchisee: {
      fontSize: '13px!important',
      textTransform: 'none',
      fontWeight: 550,
      color: '#ac2824',
    },
    logoBtnFranchisee: {
      width: 30,
      marginRight: 10,
    },
    titleModal: {
      margin: '5px 0 0 0!important',
      textTransform: 'uppercase',
      fontSize: '15px!important',
    },
    textModal: {
      textAlign: 'center',
      fontSize: '13px!important',
      marginBottom: '15px!important',
      marginTop: '0px!important',
      color: '#625e5e',
    },
    iconModal: {
      width: 40,
      height: 40,
    },
    btnModal: {
      margin: '10px 0!important',
      backgroundColor: '#a51713!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '100%',
      borderRadius: '10px!important',
    },
    btnModalSegund: {
      margin: '10px 0!important',
      color: '#75605d!important',
      backgroundColor: '#fbd3d3!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '100%',
      borderRadius: '10px!important',
    },
    btnModalWhite: {
      margin: '10px 0!important',
      border: 'solid 1px #d5c9c9!important',
      color: '#000!important',
      backgroundColor: '#fff!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '100%',
      borderRadius: '10px!important',
    },
    contentModal: {
      marginBottom: '-19px!important',
    },
    titleModalRv: {
      zIndex: 2,
      backgroundColor: '#a51614',
      textTransform: 'uppercase',
      padding: '12px 0',
      color: '#fff',
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      height: 50,
      width: '100%',
    },
    gridNameModal: {
      zIndex: 2,
      backgroundColor: '#fff',
      cursor: 'pointer',
      width: '100%',
      padding: '0 20px',
      justifyContent: 'space-between!important',
    },
    nameModal: {
      textTransform: 'uppercase',
      margin: 0,
      color: '#4d5055',
      fontSize: '16px!important',
      textAlign: 'center',
    },

    gridTitleSegund: {
      zIndex: 2,
      backgroundColor: '#fff',
      cursor: 'pointer',
      width: '100%',
      padding: '0 0px!important',
      justifyContent: 'space-between!important',
    },
    titleSegund: {
      margin: 0,
      color: '#4d5055',
      fontSize: 15,
      textAlign: 'center',
    },
    inputText: {
      margin: '5px 0!important',
      padding: '6px 40px!important',
      height: '3.5em!important',
      width: '100%',
    },
    labelText: {
      fontSize: 12,
      textAlign: 'left',
      marginTop: 5,
      fontWeight: 550,
      width: '100%',
      color: '#a51713',
    },
    content: {
      marginBottom: '-19px!important',
    },
    title: {
      zIndex: 2,
      backgroundColor: '#a51614',
      padding: '12px 0',
      color: '#fff',
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      height: 50,
      width: '100%',
    },

    form: {
      width: '100%',
    },

    gridForm: {
      padding: '0 30px',
      marginBottom: '100px!important',
    },
    inputTextCode: {
      margin: '10px 0!important',
      padding: '6px 15px!important',
      textAlign: 'center',
      height: '3.5em!important',
      width: '70%',
    },
    btnSubmit: {
      margin: '10px 0!important',
      textTransform: 'uppercase',
      backgroundColor: '#a51713!important',
      maxWidth: 680,
      width: '90%',
      borderRadius: '10px!important',
    },
    btnSubmitSegund: {
      margin: '10px 0!important',
      backgroundColor: '#fff!important',
      textTransform: 'uppercase',
      border: 'solid 1px #a51713!important',
      color: '#a51713!important',
      maxWidth: 680,
      width: '90%',
      borderRadius: '10px!important',
    },
    btnNotCodeRecive: {
      margin: '10px 0!important',
      width: '100%',
      textDecoration: 'underline!important',
      color: '#0060ff!important',
      fontSize: '12px!important',
    },

    gridTopCashback: {
      justifyContent: 'space-between',
      backgroundColor: '#F2F2F2',
      borderRadius: 5,
      padding: '2px 5px',
      marginBottom: '5px!important',
    },
    hr: {
      border: '0.5px solid #f1f1f1!important',
      margin: '5px auto!important',
      width: '100%',
    },
    gridInfoTextCashback: {
      justifyContent: 'space-between',
    },

    imgCashBack: {
      width: '100%',
      height: 'auto',
    },
    textNoBoldBackgroundColor: {
      color: '#4b4949',
    },
    textNoBoldUnderlined: {
      fontWeight: 400,
      textDecoration: 'underline',
      color: '#04f',
    },
    textFontSizeMin: {
      fontSize: '0.85rem!important',
    },
    btnCopyCodeAndLink: {
      background: '#dcdede87',
      padding: '5px 10px',
      width: '100%',

      cursor: 'pointer',
      borderRadius: '10px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
);

export default useStyles;
